import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, Pipe, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import * as i1$1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from '@angular/common';
import * as i5 from 'primeng/button';
import { PrimengLibraryModule } from 'primeng-library';

class LockUnlockStepsLibraryService {
    constructor(http) {
        this.http = http;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.onlockedUpdated = new Subject();
        this.updateNotesSubject = new BehaviorSubject({});
        this.updateNote$ = this.updateNotesSubject.asObservable();
    }
    savenotes(taskId, payload) {
        return this.http.post(`/L1/task/${taskId}/note/create`, payload).pipe(map((response) => {
            this.updateNotesSubject.next({
                notesAdded: payload.noteDetails,
                notesAvailable: true,
                taskStepId: payload.taskStepId
            });
            return response;
        }));
    }
    saveLockUnclock(payload) {
        return this.http.post(`/petitioner/preparer/updatelock`, payload).pipe(map((response) => {
            this.updateNotesSubject.next({
                locked: payload.locked,
                taskId: payload.taskId,
                stepId: payload.stepId,
                userType: payload.userType
            });
            return response;
        }));
    }
    getTask(visaType, taskId) {
        return this.http.get(`/${visaType}/task/${taskId}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
LockUnlockStepsLibraryService.ɵfac = function LockUnlockStepsLibraryService_Factory(t) { return new (t || LockUnlockStepsLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
LockUnlockStepsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: LockUnlockStepsLibraryService, factory: LockUnlockStepsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockUnlockStepsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function LockUnlockStepsLibraryComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, "Lock step for Beneficiary");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵelementStart(7, "h5");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 6);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵelement(12, "div", 8);
    i0.ɵɵelementStart(13, "div", 9);
    i0.ɵɵelementStart(14, "button", 10);
    i0.ɵɵlistener("click", function LockUnlockStepsLibraryComponent_div_0_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r3); const ctx_r2 = i0.ɵɵnextContext(); return ctx_r2.saveLockUnlock(false); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1("Step Name : ", ctx_r0.stepName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.lockUnlockMessage);
} }
function LockUnlockStepsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵelementStart(2, "div", 3);
    i0.ɵɵelementStart(3, "span");
    i0.ɵɵtext(4, " Unlock step for Beneficiary");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵelementStart(7, "h5");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p", 6);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 7);
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵelementStart(13, "button", 11);
    i0.ɵɵlistener("click", function LockUnlockStepsLibraryComponent_div_1_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r5); const ctx_r4 = i0.ɵɵnextContext(); return ctx_r4.saveLockUnlock(true); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1("Step Name : ", ctx_r1.stepName, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.lockUnlockMessage);
} }
class LockUnlockStepsLibraryComponent {
    constructor(store, lockService, toastr) {
        this.store = store;
        this.lockService = lockService;
        this.toastr = toastr;
        this._step = null;
        this.lockUnlock = new EventEmitter();
        this.isUnlocked = false;
        this.lockUnlockMessage = "";
        this.stepName = "";
        this.observableSubscription$ = new Subject$1();
        this._step = this.step;
    }
    ngOnInit() {
        this.lockService.getTask("H1-B", this.step.taskId).pipe(takeUntil(this.observableSubscription$))
            .subscribe((data) => {
            if (data.status === 200) {
                this.maindata = data.data;
                // console.log(this.maindata);
                this.step = this.maindata.taskStepDetails.find(item => item.id === this.step.id);
                // console.log("step details", this.step);
                this.userType = localStorage.getItem('userTypeRole');
                this.stepName = this.step.stepName;
                if (this.step.isBeneficiaryVisible === 1) {
                    this.lockUnlockMessage = "Do you want to lock above step for Beneficiary?  " + "\n" + "  By proceeding, Beneficiary will not be able to access/view this step";
                }
                else if (this.step.isBeneficiaryVisible === 0) {
                    this.lockUnlockMessage = "Do you want to unlock above step for Beneficiary? " + '\n' + " By proceeding, Beneficiary will be able to access/view this step";
                }
            }
        });
        // this.store.pipe(select(getStepDetails, { id: this.step.id }))
        //   .pipe(takeUntil(this.observableSubscription$))
        //   .subscribe((data: TaskStep) => {
        //     if (data && data.id) {
        //       this.step = data;
        //       this._step = this.step;
        //       this.stepName = this.step.stepName;
        //       // this.isLocked = this.step.isBeneficiaryVisible ?  true : false;
        //       this.userType = localStorage.getItem('userTypeRole');
        //       if (this.step.isBeneficiaryVisible === 1) {
        //         this.lockUnlockMessage = "Do you want to lock above step for Beneficiary. By proceeding, Beneficiary will not able to access/view this step";
        //       } else if (this.step.isBeneficiaryVisible === 0) {
        //         this.lockUnlockMessage = "Do you want to unlock above step for Beneficiary. By proceeding, Beneficiary will able to access/view this step";
        //       }
        //     }
        //   })
    }
    saveLockUnlock(e) {
        const payload = {
            locked: e,
            taskId: this.step.taskId,
            stepId: this.step.id,
            userType: this.userType
        };
        this.lockService.saveLockUnclock(payload).subscribe((response) => {
            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                this.lockUnlock.emit({
                    locked: e,
                    taskId: this.step.taskId,
                    stepId: this.step.id,
                    userType: this.userType
                });
                this.toastr.success(response.message, 'Success');
                this.lockService.onlockedUpdated.next();
            }
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
LockUnlockStepsLibraryComponent.ɵfac = function LockUnlockStepsLibraryComponent_Factory(t) { return new (t || LockUnlockStepsLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.Store), i0.ɵɵdirectiveInject(LockUnlockStepsLibraryService), i0.ɵɵdirectiveInject(i3.ToastrService)); };
LockUnlockStepsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LockUnlockStepsLibraryComponent, selectors: [["lock-unlock-steps-library"]], inputs: { step: "step", primaryData: "primaryData" }, outputs: { lockUnlock: "lockUnlock" }, decls: 2, vars: 2, consts: [["class", "notes", 4, "ngIf"], [1, "notes"], [1, "col-md-12", "p-0", "row", "lock-header"], [1, "col-md-10", "p-0"], [1, "col-md-2", "p-0", "justify-content-end", "d-flex"], [1, "row", "col-md-12", "p-0", "lock-body"], [1, "content"], [1, "row", "col-md-12", "justify-content-end", "d-flex", "pr-0", "lock-buttons"], [1, "col-md-3"], [1, "col-md-6"], ["pButton", "", "type", "button", "label", "YES, LOCK NOW", 3, "click"], ["pButton", "", "type", "button", "label", "YES, UNLOCK NOW", 3, "click"]], template: function LockUnlockStepsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, LockUnlockStepsLibraryComponent_div_0_Template, 15, 2, "div", 0);
        i0.ɵɵtemplate(1, LockUnlockStepsLibraryComponent_div_1_Template, 14, 2, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.step.isBeneficiaryVisible === 1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.step.isBeneficiaryVisible === 0);
    } }, directives: [i4.NgIf, i5.ButtonDirective], styles: [".close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:10px;border-radius:20px;cursor:pointer;font-size:14px}.lock-header[_ngcontent-%COMP%]{color:#4d4f5c;border-bottom:1px dashed #707070;font-size:22px;font-weight:700;text-align:left;padding:15px 0 10px!important}.lock-body[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font-size:16px;padding:25px 0 0;font-weight:600;text-align:left}.lock-body[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{padding:10px 0 20px;margin-bottom:0;font-size:14px;text-align:left;line-height:20px}.lock-body[_ngcontent-%COMP%]   .content[_ngcontent-%COMP%]{white-space:pre-line}.lock-buttons[_ngcontent-%COMP%]{border-top:1px dashed #707070;padding:20px 0 0!important;text-align:right}.cancel-btn[_ngcontent-%COMP%]{color:#656565;background:#efefef;border:1px solid #efefef}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockUnlockStepsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lock-unlock-steps-library',
                templateUrl: `lock-unlock-steps-library.component.html`,
                styleUrls: ['lock-unlock-steps-library.component.scss'],
            }]
    }], function () { return [{ type: i1$1.Store }, { type: LockUnlockStepsLibraryService }, { type: i3.ToastrService }]; }, { step: [{
            type: Input
        }], lockUnlock: [{
            type: Output
        }], primaryData: [{
            type: Input
        }] }); })();

class nl2brPipe {
    transform(value) {
        return value.replace(/\n/g, '<br/>');
    }
}
nl2brPipe.ɵfac = function nl2brPipe_Factory(t) { return new (t || nl2brPipe)(); };
nl2brPipe.ɵpipe = i0.ɵɵdefinePipe({ name: "nl2br", type: nl2brPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(nl2brPipe, [{
        type: Pipe,
        args: [{
                name: 'nl2br'
            }]
    }], null, null); })();

class LockUnlockStepsLibraryModule {
}
LockUnlockStepsLibraryModule.ɵfac = function LockUnlockStepsLibraryModule_Factory(t) { return new (t || LockUnlockStepsLibraryModule)(); };
LockUnlockStepsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: LockUnlockStepsLibraryModule });
LockUnlockStepsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LockUnlockStepsLibraryModule, { declarations: [LockUnlockStepsLibraryComponent, nl2brPipe], imports: [PrimengLibraryModule], exports: [LockUnlockStepsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(LockUnlockStepsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [LockUnlockStepsLibraryComponent, nl2brPipe],
                imports: [
                    PrimengLibraryModule,
                ],
                exports: [LockUnlockStepsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of lock-unlock-steps-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LockUnlockStepsLibraryComponent, LockUnlockStepsLibraryModule, LockUnlockStepsLibraryService };
//# sourceMappingURL=lock-unlock-steps-library.js.map
